(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magnanova-campaign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function mount(section) {
      if (section.dataset.mounted) return;
      section.dataset.mounted = 'true';
      const video = section.querySelector('video');
      const control = section.querySelector('.mn-campaign__pause');
      const mobile = matchMedia('(max-width: 749px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = false;
      let entered = false;
      section.classList.add('mn-campaign--waiting');
      const play = () => {
        if (reduced.matches || userPaused || document.hidden) return;
        video.muted = true;
        video.play().then(() => {
          section.classList.add('mn-campaign--playing');
          section.classList.remove('mn-campaign--paused');
          control.hidden = false;
          control.setAttribute('aria-label', control.dataset.pauseLabel);
        }).catch(() => {
          section.classList.add('mn-campaign--paused');
          control.hidden = !video.src;
          control.setAttribute('aria-label', control.dataset.playLabel);
        });
      };
      const source = () => {
        video.pause();
        video.poster = mobile.matches ? section.dataset.mobilePoster : section.dataset.desktopPoster;
        const url = mobile.matches ? section.dataset.mobileSrc : section.dataset.desktopSrc;
        if (!url) { video.removeAttribute('src'); control.hidden = true; return; }
        video.src = url;
        if (entered) play();
      };
      const enter = () => {
        if (entered) return;
        entered = true;
        section.classList.remove('mn-campaign--waiting');
        section.classList.add('mn-campaign--enter');
        if (!reduced.matches && video.getAttribute('src')) play();
      };
      source();
      if (document.documentElement.dataset.mnIntroState === 'playing') {
        document.addEventListener('magnanova:intro-reveal', play, { once: true });
        document.addEventListener('magnanova:intro-finished', enter, { once: true });
      } else enter();
      control.addEventListener('click', () => {
        userPaused = !video.paused;
        if (userPaused) {
          video.pause();
          section.classList.add('mn-campaign--paused');
          control.setAttribute('aria-label', control.dataset.playLabel);
        } else play();
      });
      video.addEventListener('error', () => { section.classList.remove('mn-campaign--playing'); control.hidden = true; enter(); });
      mobile.addEventListener('change', source);
      reduced.addEventListener('change', () => {
        if (reduced.matches) { video.pause(); control.hidden = true; }
        else play();
      });
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else if (entered) play(); });
    }
    document.querySelectorAll('.mn-campaign').forEach(mount);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.mn-campaign').forEach(mount));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magnanova-club-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
 const desktop = matchMedia('(min-width: 750px)');
 const update = () => document.querySelectorAll('.mn-footer__accordion').forEach(item => { item.open = desktop.matches; });
 update();
 desktop.addEventListener('change', update);
 document.addEventListener('shopify:section:load', update);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
